import type {
  RechercheQueryDossierReservationFondsDTO,
  RechercheResultDossierReservationFondsDTO,
} from '@/features/api/extranet/dto/Dossier/Recherche/ReservationFonds'
import { buildRechercheStore } from '../shared'

export const API_PATH_DRF_DOSSIERS = '/reservationsfonds'

export const useDRFRechercheDossierStore = buildRechercheStore<
  RechercheQueryDossierReservationFondsDTO,
  RechercheResultDossierReservationFondsDTO
>({
  storeName: 'rechercheDRFDossierStore',
  apiPath: API_PATH_DRF_DOSSIERS,
  location: {
    to: 'recherche',
    domaine: 'drf',
    module: 'dossier'
  }
})
